/**
 * @description Decode the REST fetch response into JSON, if present
 * @param resp {Response} - api response object
 * @returns {Promise} - resolves with the JSON response (non-JSON response is resolved with undefined);
 *  if the request fails, the promise is rejected
 */

function decodeJson (resp) {
  return new Promise((resolve, reject) => {
    // Determine if the response is a JSON response
    const contentType = resp.headers.get('content-type');
    const isJson = Boolean(contentType) && contentType.includes('application/json');

    /**
     * Resolves or rejects the promise based on if the response is OK or not
     * @param responseBody {object} - decoded api response
     */
    function checkResponse (responseBody) {
      if (resp.ok) {
        resolve(responseBody);
      } else {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject({ body: responseBody, status: resp.status });
      }
    }

    // If it's JSON parse the JSON and check the response
    // If it's not JSON, check the response with an undefined response body
    if (isJson) {
      resp.json()
        .then(checkResponse);
    } else {
      checkResponse();
    }
  });
}

export default decodeJson;
